import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const sleepSteps = [
  {
    number: 1,
    title: 'Get Comfortable in Bed',
    description: 'Lie down in your most comfortable sleeping position. Use pillows and blankets to support your body fully.'
  },
  {
    number: 2,
    title: 'Gentle Eye Closure',
    description: 'Softly close your eyes and let them rest. Allow your facial muscles to relax completely.'
  },
  {
    number: 3,
    title: 'Release Physical Tension',
    description: 'Starting from your toes and working up to your head, consciously release tension from each part of your body.'
  },
  {
    number: 4,
    title: 'Follow the Guided Journey',
    description: 'Let the soothing voice guide you into deep relaxation. Allow yourself to drift naturally into peaceful sleep.'
  }
];

const SleepingMeditationSession1: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Sleeping Meditation Session 1',
      description: 'Completed Sleeping Meditation Session 1.',
      image: require('../assets/sleeping.png').default || require('../assets/sleeping.png'),
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(session)
      });
    } catch (err) {

    }
    navigate('/panel/dashboard/sleeping-meditation');
  };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 1: Sleep Meditation</h1>
              <p className="session-description">
                Drift into peaceful, restorative sleep with this gentle guided meditation. Perfect for winding down and preparing your mind and body for rest.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/rvaqPPjtxng"
                  title="Session 1: Sleep Meditation"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Meditate for Sleep</h2>
                <div className="session-steps">
                  {sleepSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
export default SleepingMeditationSession1;

